import axiosInstance from './axiosInstance';
import { endpoints } from './endPoints';
import { setIdleSessionPolicy, getIdleSessionPolicy } from 'shared/utils/idleSessionConfig';

export async function fetchSessionPolicy() {
  try {
    const res = await axiosInstance.get(endpoints.authentication.sessionPolicy);
    const data = res?.data?.data;
    if (data && typeof data === 'object') {
      return setIdleSessionPolicy({
        idleTimeoutMs: data.idleTimeoutMs,
        warningLeadMs: data.warningLeadMs,
        absoluteTimeoutMs: data.absoluteTimeoutMs,
        accessTokenExpirationMs: data.accessTokenExpirationMs,
      });
    }
  } catch (e) {
    // Fall back to env / defaults.
  }
  return getIdleSessionPolicy();
}

let lastActivityPostAt = 0;

/** Notify backend of user activity (throttled). */
export async function postSessionActivity() {
  const now = Date.now();
  if (now - lastActivityPostAt < 25_000) return;
  lastActivityPostAt = now;
  try {
    await axiosInstance.post(endpoints.authentication.activity, {});
  } catch {
    // Ignore — next authenticated API call or idle FE timer still applies.
  }
}

export async function postSessionRestored() {
  try {
    await axiosInstance.post(endpoints.authentication.sessionRestored, {});
  } catch {
    // Non-blocking audit.
  }
}
